import React, { useMemo, useRef, useState } from "react";
import { BiArrowBack } from "react-icons/bi";
import { BsArrowRight } from "react-icons/bs";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import PageTitle from "../../../../components/partials/PageTitle";
import PolicySavingsScheduleDoc from "../../../../components/policy/PolicySavingsScheduleDoc";
import PolicyWording from "../../../../components/policy/PolicyWording";
import { GenericPdfDownloader } from "../../../../utils/helpers/functions";
import { MdOutlineArrowLeft, MdOutlineArrowRight } from "react-icons/md";
import PolicyPaymentSchedule from "../../../../components/policy/PolicyPaymentSchedule";

const SavingsPolicyDocument = () => {
  const { policyScheduleData } = useSelector((state) => state.underwriting);
  const { covers } = useSelector((state) => state.savingsPolicy);
  const [activePage, setActivePage] = useState("schedule");
  const [activeTab, setActiveTab] = useState("policy-info");

  const breadcrumb = {
    from: {
      title: "policy schedule",
      link: "/admin/customer-policy-view/policy-schedule",
    },
    current: {
      title: "policy schedule",
      link: null,
    },
  };

  const schedule = useRef();
  const navigate = useNavigate();

  // Print schedule document to PDF
  const generatePDF = useReactToPrint({
    content: () => schedule.current,
    documentTitle: `${
      activePage === "schedule" ? "Schedule" : "Policy Wording"
    }`,
  });

  const RiskPremiumTotal = useMemo(
    () =>
      policyScheduleData?.policy_app_rsk?.reduce(
        (total, item) => total + parseFloat(item.premium),
        0
      ),
    [policyScheduleData?.policy_app_rsk]
  );

  return (
    <>
      {/* Page title */}
      <PageTitle
        title='Policy Schedule'
        breadcrumb={breadcrumb}
      />

      <div className='card'>
        <div className='card-body'>
          <div className='d-flex justify-content-between mb-4'>
            <span className='text-uppercase text-primary p-0 fw-bold'>
              Policy Document
            </span>
            <button
              type='button'
              className='btn btn-sm btn-primary d-flex align-items-center'
              onClick={() => navigate(-1)}
            >
              <BiArrowBack />
              <span>Back</span>
            </button>
          </div>
          {activeTab === "policy-info" && (
            <div ref={schedule} id='schedule'>
              <PolicySavingsScheduleDoc
                data={policyScheduleData?.policy_app_details}
                life_cover={policyScheduleData?.life_cover}
              />
              <div
                className='d-flex justify-content-center align-items-center h-50 w-100'
                style={{ backgroundColor: "#727CF5" }}
              >
                <h5
                  className='text-uppercase text-white fw-bold font-22'
                  style={{ fontSize: "35px" }}
                >
                  RISK COVERS
                </h5>
              </div>
              <div>
                <table className='table table-hover'>
                  <thead>
                    <tr>
                      <th scope='col'>Cover Name</th>
                      <th scope='col'>Rate</th>
                      <th scope='col'>Sum Assured</th>
                      <th scope='col'>Premium</th>
                      <th scope='col'>Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    {policyScheduleData?.policy_app_rsk?.map((item, index) => (
                      <tr key={index}>
                        <td className='text-capitalize'>
                          {covers?.get_other_cover?.filter(
                            (p) => p.id === item?.cover_id
                          ).length
                            ? covers?.get_other_cover?.filter(
                                (p) => p.id === item?.cover_id
                              )[0]?.cover_name
                            : item?.cover_name}
                        </td>
                        <td>{item?.rate}</td>
                        <td>{item?.sum_assured}</td>
                        <td>&#x20A6;{item?.premium}</td>
                        <td>{item?.desc}</td>
                      </tr>
                    ))}
                    <tr>
                      <td className='text-capitalize fw-bold'>
                        Total Cover Premium
                      </td>
                      <td></td>
                      <td></td>
                      <td className='fw-bold'>
                        &#x20A6;{RiskPremiumTotal.toFixed(2)}
                      </td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div>
                <p>
                  <span className='fw-bold text-uppercase'>Death Benefit Claim Name: </span>
                  {policyScheduleData?.death_claim?.life_cover_claim_name === "multiple" && (
                    <>
                      <span>Multiple</span>
                    </>
                  )}
                  {policyScheduleData?.death_claim?.life_cover_claim_name === "assumed" && (
                    <>
                      <span>Assumed Sum Assured</span>
                    </>
                  )}
                  {policyScheduleData?.death_claim?.life_cover_claim_name === "guaranteed" && (
                    <>
                      <span>Guaranteed Sum Assured</span>
                    </>
                  )}
                </p>
                {policyScheduleData?.death_claim?.life_cover_claim_name === "guaranteed" && <p>
                <span className='fw-bold text-uppercase'>Guaranteed Type: </span>
                {policyScheduleData?.death_claim?.assumed_garranty_type === "fixed" && (
                  <>
                    <span>Fixed</span>
                  </>
                )}
                {policyScheduleData?.death_claim?.assumed_garranty_type === "range" && (
                  <>
                    <span>Range</span>
                  </>
                )}
                </p>}
                {policyScheduleData?.death_claim?.life_cover_claim_name === "multiple" && <p>
            <span className='fw-bold text-uppercase'>Death Benefit Amount: </span>
            {JSON.parse(policyScheduleData?.death_claim?.multiple_value)?.map((item, i) => (
                          <span
                            className='bg-primary text-light fs-6 text-capitalize'
                            style={{ padding: "4px", margin: "0px 4px" }}
                            key={i}
                          >
                            {item}
                          </span>
                      ))}
                </p>} {policyScheduleData?.death_claim?.life_cover_claim_name === "multiple" &&<br />}
                {policyScheduleData?.death_claim?.life_cover_claim_name === "guaranteed" && 
                  <div className="mt-2">
                    {policyScheduleData?.death_claim?.assumed_garranty_type === "fixed" && <p>
                      <span className='fw-bold text-uppercase'>Death Benefit Amount: </span>
                      <span className="">{policyScheduleData?.death_claim?.assumed_garranty_value}</span>
                    </p>}
                    {policyScheduleData?.death_claim?.assumed_garranty_type === "range" && <p>
                      <span className='fw-bold text-uppercase'>Guaranteed Minimum Amount: </span>
                      {policyScheduleData?.death_claim?.assumed_garranty_minimum}
                      <span className='fw-bold text-uppercase ms-2'>Guaranteed Maximum Amount: </span>
                      {policyScheduleData?.death_claim?.assumed_garranty_maximum}
                    </p>}
                  </div> 
                }
              </div>
            </div>
          )}
          {activeTab === "policy-clauses" && (
            <div ref={schedule} id='schedule'>
              {policyScheduleData?.clauses?.length ? (
                <div>
                  <PolicyWording clauses={policyScheduleData?.clauses} />
                  <div className='d-flex justify-content-between mt-5'>
                    <div
                      style={{ width: "350px" }}
                      className='d-grid place-items-center '
                    >
                      <div
                        style={{
                          height: "50px",
                          width: "80px",
                          paddingLeft: "20px",
                        }}
                        className=''
                      >
                        {policyScheduleData?.policy_app_details
                          ?.customer_signature && (
                          <img
                            src={
                              policyScheduleData?.policy_app_details
                                ?.customer_signature
                            }
                            alt='customer_signature'
                            className='w-100'
                          />
                        )}
                      </div>
                      <div className='border-top border-dotted pt-2'>
                        <span className=' fw-bold '>
                          {policyScheduleData?.policy_app_details
                            ?.customerFirstName +
                            " " +
                            policyScheduleData?.policy_app_details
                              ?.customerLastName}
                        </span>
                        <span className=''>(Signature)</span>
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
          )}

          {activeTab === "payment-schedule" && (
            <div ref={schedule} id={'schedule'}>
              <PolicyPaymentSchedule data={policyScheduleData?.policy_app_details} />
            </div>
          )}

          <div className='text-center mt-2'>
            <MdOutlineArrowLeft
              size={30}
              onClick={() => {
                if (activeTab === 'policy-clauses') {
                  setActiveTab('policy-info');
                } else if (activeTab === 'payment-schedule') {
                  setActiveTab('policy-clauses');
                }
              }}
            />
            <span style={{ fontSize: 14 }}>
              {activeTab === "policy-info" ? 1 : activeTab === "policy-clauses" ? 2 : 3} of 3
            </span>
            <MdOutlineArrowRight
              size={30}
              onClick={() => {
                if (activeTab === 'policy-info') {
                  setActiveTab('policy-clauses');
                } else if (activeTab === 'policy-clauses') {
                  setActiveTab('payment-schedule');
                }
              }}
            />
          </div>

          <div className='d-flex gap-2 justify-content-end mt-4 mb-2'>
            <button
              type='button'
              className='btn btn-sm btn-primary text-center'
              onClick={() => {
                generatePDF();
              }}
            >
              Print
            </button>
            <GenericPdfDownloader
              rootElementId={"schedule"}
              downloadFileName={`${
                activePage === "schedule" ? "Schedule" : activePage === "poliy-info" ? "Policy Wording" : 'Policy Payment Schedule'
              }`}
            />
            <button
              className='btn btn-sm btn-success d-flex gap-1 align-items-center'
              onClick={() => {
                navigate("/admin/customer-savings-policy-view", {
                  state: {
                    customerId:
                      policyScheduleData?.policy_app_details.customerId,
                    policyAppNumber:
                      policyScheduleData?.policy_app_details.policyAppNumber,
                  },
                });
              }}
            >
              <span>Continue</span>
              <BsArrowRight />
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default SavingsPolicyDocument;
